import { useCallback, useContext } from "react";
import { Divider, Typography } from "@mui/material";
import { GlobalModalContext } from "src/utils/GlobalModal/GlobalModalContext";
import __ from "src/utils/Translations";
import { useAcceptAbsenceRequests } from "src/Pages/Company/Absences/api/absenceRequests.queries";
import { StatusChip } from "src/Pages/Company/Absences/AbsenceRequest/StatusChip";
import formatDateRangePreview from "src/utils/Company/Absences/formatDateRangePreview";
import { IAbsenceRequestListItem } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import EmployeeDetails from "src/Pages/Company/Absences/EmployeeDetails";

export const useConfirmAcceptance = () => {
  const { setModal, resetModal } = useContext(GlobalModalContext);

  const { mutate: acceptAbsenceRequests, isPending } =
    useAcceptAbsenceRequests(resetModal);

  const confirmAcceptanceMultiple = useCallback(
    (
      absenceRequests: IAbsenceRequestListItem[] = [],
      total: number,
      resetRowSelection: () => void
    ) => {
      const absenceRequestIds = absenceRequests.map(
        (absenceRequest) => absenceRequest.absenceRequestId
      );

      const absenceRequestsWithETags = absenceRequests.map(
        (absenceRequest) => ({
          absenceRequestId: absenceRequest.absenceRequestId,
          eTag: absenceRequest.eTag,
        })
      );

      if (typeof setModal === "function") {
        setModal({
          open: true,
          title: <>{__("Czy na pewno chcesz potwierdzić wnioski?")}</>,
          customElements: (
            <>
              {absenceRequests.map((absenceRequest) => (
                <>
                  <EmployeeDetails data={absenceRequest.employee} showFk />
                  <Typography variant="body2" color="grey.600" mb="1rem">
                    {absenceRequest.absenceType.name}
                    <br />
                    {__("Termin wniosku")}:<br />
                    {formatDateRangePreview(absenceRequest.absenceTimes)}
                  </Typography>
                  <StatusChip variant={absenceRequest.status} />
                  <Divider sx={{ mt: "1rem" }} />
                </>
              ))}
              <Typography textAlign="center" mt="1rem" fontWeight={700}>
                {__("Wybrano")}: {absenceRequests.length} {__("z")} {total}
              </Typography>
            </>
          ),
          actions: [
            {
              label: __("Anuluj"),
              variant: "outlined",
              loading: isPending,
              callbackFn: () => {
                resetModal();
              },
            },
            {
              label: __("Potwierdź wszystkie"),
              variant: "contained",
              loading: isPending,
              callbackFn: () => {
                acceptAbsenceRequests({
                  absenceRequests: absenceRequestIds,
                  absenceRequestsWithETags,
                });
                resetRowSelection();
              },
            },
          ],
        });
      }
    },
    [acceptAbsenceRequests, isPending, resetModal, setModal]
  );

  return { confirmAcceptanceMultiple };
};
